import {
  EVENT_FORMAT_LABELS,
  EVENT_ROLE_LABELS,
  EVENT_SIZE_LABELS,
  SUBMISSION_KINDS,
} from './Constants';

export const eventDetails = (submission) => {
  if (submission.kind !== SUBMISSION_KINDS.event) {
    return [];
  }

  return [
    { label: 'Role', value: EVENT_ROLE_LABELS[submission.role] },
    { label: 'Format', value: EVENT_FORMAT_LABELS[submission.virtual] },
    { label: 'Audience size', value: EVENT_SIZE_LABELS[submission.size] },
  ];
};

export const eventSummary = submission => eventDetails(submission)
  .map(detail => detail.value)
  .filter(Boolean)
  .join(' · ');
